// src/components/LegendCard.js
import React, { useMemo } from "react";
import {
  Paper,
  Typography,
  Box,
  Stack,
  Divider,
  Tooltip,
  Chip, // EKLENDİ: Fazları listelemek için
} from "@mui/material";
import {
  Style,
  AccountTree,
  Terrain,
  Layers,
  Info,
  WaterDrop,
  Science,
} from "@mui/icons-material";
import { calculateLegend } from "../../utils/legendUtils";

export default function LegendCard({ formData }) {
  // Utils dosyasından veriyi 4 parça halinde (Sol, Pay, Payda, Sağ) alıyoruz
  const legendData = useMemo(() => {
    return calculateLegend(formData);
  }, [formData]);

  // EKLENDİ: Payda kısmındaki (Örn: T1 R2 E1) kodları diziye çeviriyoruz
  const phasesArray = legendData.bottomString
    ? legendData.bottomString.split(" ")
    : [];

  // Alt detay kutucuklarının tasarımı
  const DetailChip = ({ label, value, icon }) => (
    <Box
      sx={{
        textAlign: "center",
        p: 1,
        bgcolor: "rgba(255, 255, 255, 0.5)",
        borderRadius: 2,
        flex: 1,
        border: "1px dashed rgba(0, 0, 0, 0.1)",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        spacing={0.5}
        mb={0.5}
      >
        {icon}
        <Typography variant="caption" color="text.secondary" fontWeight="bold">
          {label}
        </Typography>
      </Stack>
      <Typography variant="subtitle1" fontWeight="900" color="primary.dark">
        {value === "?" || !value ? "-" : value}
      </Typography>
    </Box>
  );

  return (
    <Paper
      elevation={3}
      sx={{
        p: 2,
        borderRadius: 2,
        bgcolor: "#e3f2fd", // AKK sarıydı, bu ayırt edici ama uyumlu pastel mavi
        border: "1px solid #bbdefb",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* ÜST BAŞLIK */}
      <Stack direction="row" alignItems="center" spacing={1} mb={2}>
        <AccountTree color="primary" />
        <Typography variant="h6" fontWeight="bold" color="text.primary">
          Seri Formülü
        </Typography>
        <Tooltip title="Belge formatı: Sol (Profil Grubu), Pay (Seri/Bünye/Eğim vb), Payda (Fazlar), Sağ (Kullanım)">
          <Info fontSize="small" color="disabled" sx={{ cursor: "help" }} />
        </Tooltip>
      </Stack>

      {/* MERKEZ: AKK GİBİ KESİRLİ (BÖLÜM/BÖLEN) YAPI */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: 3,
          py: 2,
          flexGrow: 1,
        }}
      >
        {/* SOL: PROFİL GRUBU (Örn: XI) */}
        <Box sx={{ textAlign: "center" }}>
          <Typography
            variant="h2"
            fontWeight="bold"
            color="error.main" // AKK'daki gibi kırmızı vurgu
            sx={{ lineHeight: 1 }}
          >
            {legendData.leftCode}
          </Typography>
        </Box>

        {/* ORTA: KESİRLİ YAPI (Pay: Temel Veriler / Payda: Fazlar) */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            mx: 2,
          }}
        >
          <Typography
            variant="h5"
            fontFamily="monospace"
            fontWeight="bold"
            color="#333"
            sx={{ letterSpacing: 2 }}
          >
            {legendData.topString || "???"}
          </Typography>

          <Divider
            sx={{
              width: "100%",
              borderBottomWidth: 3,
              borderColor: "#000",
              my: 0.5,
            }}
          />

          <Typography
            variant="h5"
            fontFamily="monospace"
            fontWeight="bold"
            color="#333"
            sx={{ letterSpacing: 2, minHeight: "32px" }}
          >
            {/* Faz yoksa boş kalmasın diye tire koyuyoruz */}
            {legendData.bottomString || "-"}
          </Typography>
        </Box>

        {/* SAĞ: ARAZİ KULLANIM ŞEKLİ (Örn: K) */}
        {legendData.rightCode && (
          <Box sx={{ ml: 1 }}>
            <Typography
              variant="h4"
              fontFamily="monospace"
              color="text.primary"
              fontWeight="bold"
            >
              {legendData.rightCode}
            </Typography>
          </Box>
        )}
      </Box>
    </Paper>
  );
}
